export const FORM_ACTIONS = {
  'ADD_FORM': 'ADD_FORM',
  'ADD_FORMS': 'ADD_FORMS', // Will reduce the number of times store subscription runs
  'REMOVE_FORM': 'REMOVE_FORM',
  'ADD_DATABINDINGS': 'ADD_DATABINDINGS',
  'ADD_CONFIG_BINDINGS': 'ADD_CONFIGBINDINGS',
  'REMOVE_DATABINDINGS': 'REMOVE_DATABINDINGS',
  'REMOVE_CONFIG_BINDINGS': 'REMOVE_CONFIGBINDINGS',
  'ADD_FORM_PROPS': 'ADD_FORM_PROPS',
  'REMOVE_FORM_PROPS': 'REMOVE_FORM_PROPS',
  'UPDATE_FORM_CONTROLS': 'UPDATE_FORM_CONTROLS'
};
